import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/blade-system/dept/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getLazyList = (parentId, params = {}) => {
  return request({
    url: '/api/blade-system/dept/lazy-list',
    method: 'get',
    params: {
      ...params,
      parentId,
      showIs: 0,
      deptType: 1,
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/blade-system/dept/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/blade-system/dept/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/blade-system/dept/submit',
    method: 'post',
    data: row
  })
}

export const getDept = (id) => {
  return request({
    url: '/api/blade-system/dept/detail',
    method: 'get',
    params: {
      id,
    }
  })
}

/**
 * 部门树；tenantId 由后台从登录 Token 解析，无需传入
 * @param {Object} [extra] 如 deptType、showIs
 */
export const getDeptTree = (extra = {}) => {
  return request({
    url: '/api/blade-system/dept/tree',
    method: 'get',
    params: { ...extra },
  })
}

/**
 * 部门懒加载树；tenantId 由后台从登录 Token 解析，无需传入
 * @param parentId
 * @param {Object} [extra] 如 deptType、showIs
 */
export const getDeptLazyTree = (parentId, extra = {}) => {
  return request({
    url: '/api/blade-system/dept/lazy-tree',
    method: 'get',
    params: {
      parentId,
      ...extra,
    },
  })
}

